import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/** NotificationItem do DS (ORCA-1929): uma linha do sino. `detail` = forma escolhida na aprovação. */
@Component({
    selector: 'oa-notification-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="oa-notif" [class.oa-notif--unread]="unread">
            <span class="oa-notif__icon oa-notif__icon--{{ tone }}" aria-hidden="true"><mat-icon>{{ icon }}</mat-icon></span>
            <span class="oa-notif__text">
                <span>{{ title }}</span>
                <b *ngIf="detail">{{ detail }}</b>
                <small *ngIf="time">{{ time }}</small>
            </span>
            <span *ngIf="unread" class="oa-notif__dot"><span class="cdk-visually-hidden">Não lida</span></span>
        </div>
    `,
})
export class OaNotificationItemComponent {
    @Input() title = '';
    @Input() detail?: string;
    @Input() time?: string;
    @Input() icon = 'notifications';
    @Input() tone: 'success' | 'info' | 'danger' = 'info';
    @Input() unread = false;
}
